const HDWalletProvider = require("@truffle/hdwallet-provider");
import Web3 from 'web3';

const provider  = new HDWalletProvider({
    mnemonic: {
        phrase: 'fun dismiss pyramid hawk trumpet crucial logic pioneer chronic camera happy core'
    },
    providerOrUrl: new Web3.providers.WebsocketProvider(`wss://eth-mainnet.ws.alchemyapi.io/v2/xzmYllZWkAng1hNQdBdUsULTZeKYZlVQ`)
});
provider.autoRefreshOnNetworkChange = false;

export default new Web3(provider);